import * as React from 'react';
import {
    Edit,
    TextInput,
    SimpleForm,
    BooleanInput,
    NumberInput,
    required,
} from 'react-admin';
import { Grid } from '@mui/material';

import Aside from './Aside';
import FullNameField from './FullNameField';

const req = [required()];

const EntityEdit = () => {
    return (
        <Edit
            title={<EditTitle />}
            resource="logix_packings"
            aside={<Aside />}
            redirect={false}
            mutationMode="pessimistic"
        >
            <SimpleForm>
                <div>
                    <Grid
                        container
                        width={{ xs: '100%', xl: '80%' }}
                        spacing={2}
                    >
                        <Grid item xs={12} md={10} xl={12}>
                            <NumberInput
                                source="service_id"
                                min={1}
                                step={1}
                                validate={req}
                                isRequired
                                fullWidth
                            />
                            <TextInput
                                source="title"
                                validate={req}
                                isRequired
                                fullWidth
                            />
                            <TextInput
                                source="title_short"
                                validate={req}
                                isRequired
                                fullWidth
                            />
                            <TextInput
                                source="type"
                                validate={req}
                                isRequired
                                fullWidth
                            />
                            <TextInput
                                source="group"
                                validate={req}
                                isRequired
                                fullWidth
                            />
                            <TextInput
                                source="unit"
                                validate={req}
                                isRequired
                                fullWidth
                            />
                            <NumberInput
                                source="unit_code"
                                min={1}
                                step={1}
                                validate={req}
                                isRequired
                                fullWidth
                            />
                            <BooleanInput source="active" fullWidth />
                            <BooleanInput source="is_transport" fullWidth />
                            <TextInput
                                source="helper"
                                fullWidth
                                multiline
                                maxRows={10}
                            />
                        </Grid>
                    </Grid>
                </div>
            </SimpleForm>
        </Edit>
    );
};

// @ts-ignore
const EditTitle = () => <FullNameField size="32" sx={{ margin: '5px 0' }} />;

export default EntityEdit;
